var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevrondoubledown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9211 10.3708C41.568 11.0177 41.568 12.0663 40.9211 12.7131L27.6711 25.9631C27.0243 26.6099 25.9757 26.6099 25.3289 25.9631L12.0789 12.7131C11.4321 12.0663 11.4321 11.0177 12.0789 10.3708C12.7257 9.72404 13.7743 9.72404 14.4211 10.3708L26.5 22.4497L38.5789 10.3708C39.2257 9.72404 40.2743 9.72404 40.9211 10.3708ZM40.9211 28.0375C41.568 28.6843 41.568 29.733 40.9211 30.3798L27.6711 43.6298C27.0243 44.2766 25.9757 44.2766 25.3289 43.6298L12.0789 30.3798C11.4321 29.733 11.4321 28.6843 12.0789 28.0375C12.7257 27.3907 13.7743 27.3907 14.4211 28.0375L26.5 40.1164L38.5789 28.0375C39.2257 27.3907 40.2743 27.3907 40.9211 28.0375Z",
    fill: "url(#paint0_linear_2864_481)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2864_481",
    x1: 26.5,
    y1: 9.91033,
    x2: 26.5,
    y2: 44.1395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D802BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7DB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevrondoubledown);
export default __webpack_public_path__ + "static/media/icon_chevrondoubledown.deebc54c68bbc3af34effe3bc88820b6.svg";
export { ForwardRef as ReactComponent };